import React from "react";


class ModernBg1 extends React.Component {



    render() {
        return (
            <div className="position-absolute top-0 left-0 w-100 h-100 overflow-hidden pointer-none">
                <div className="w-100 h-100 overflow-hidden">
                    <div style={{ height: 500, width: 500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>

                    </div>

                    <div style={{ height: 500, width: 500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(255, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>

                    </div>
                </div>
            </div>
        );

    }
}




export default ModernBg1;
